<section class="sidebar h-full relative">
	<!-- ----- Mode étendu -->
	<div
		class="absolute inset-0 flex flex-col"
		[inert]="!sidebar.isOpen()"
		[attr.aria-hidden]="!sidebar.isOpen()"
		[class]="sidebar.isOpen() ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'">
		<div class="sidebar__header flex items-center gap-3 px-4 flex-shrink-0">
			<img [src]="clubIcon()" alt="" class="sidebar__logo" />
			<div class="min-w-0 flex-1">
				<div class="sidebar__eyebrow">Navigation</div>
				<span class="sidebar__club-name truncate block">{{ clubName() }}</span>
			</div>
			<button class="sidebar__collapse" (click)="sidebar.toggle()" aria-label="Réduire le menu">
				<lucide-icon [img]="lucidePanelLeft" [size]="15" />
			</button>
		</div>

		<div class="sidebar__menu flex-1 overflow-y-auto overflow-x-hidden">
			@if (panelMenuItems().length > 0) {
			<p-panelMenu [model]="panelMenuItems()" [multiple]="true">
				<!-- Un seul chevron, qui pivote : PrimeNG échangerait deux SVG, ce qui interdit toute transition -->
				<ng-template #headericon>
					<span class="p-panelmenu-submenu-icon"><lucide-icon [img]="lucideChevronRight" [size]="14" /></span>
				</ng-template>
				<ng-template #submenuicon>
					<span class="p-panelmenu-submenu-icon"><lucide-icon [img]="lucideChevronRight" [size]="14" /></span>
				</ng-template>
			</p-panelMenu>
			} @else {
			<div class="flex items-center justify-center h-full text-slate-400">
				<i class="pi pi-spin pi-spinner text-3xl"></i>
			</div>
			}
		</div>

		<div class="sidebar__search flex-shrink-0">
			<p-iconfield>
				<p-inputicon styleClass="pi pi-search" />
				<input
					type="text"
					pInputText
					data-dict-key="select"
					[placeholder]="Dic.select.text"
					(input)="onSearch($event)"
					class="w-full"
					pSize="small" />
			</p-iconfield>
		</div>
	</div>

	<!-- ----- Mode réduit : rail d'icônes -->
	<div
		class="absolute inset-0 flex flex-col"
		[inert]="sidebar.isOpen()"
		[attr.aria-hidden]="sidebar.isOpen()"
		[class]="!sidebar.isOpen() ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'">
		<div class="sidebar__header sidebar__header--mini flex-shrink-0">
			<div class="sidebar__logo-slot">
				<img [src]="clubIcon()" alt="" class="sidebar__logo" />
				<button class="sidebar__collapse sidebar__collapse--overlay" (click)="sidebar.toggle()" aria-label="Déployer le menu">
					<lucide-icon [img]="lucidePanelLeft" [size]="15" />
				</button>
			</div>
		</div>

		<nav class="sidebar__rail">
			@for (item of railItems(); track item.id) {
			<div class="rail-slot">
				<button
					class="rail-item"
					[class.rail-item--active]="item.styleClass?.includes('active-menu-item') || item.styleClass?.includes('active-menu-branch')"
					[class.rail-item--open]="flyoutItem() === item"
					(mousedown)="$event.stopPropagation()"
					(click)="onRailClick(item, $event)"
					(mouseenter)="showRailTip($event, item.label)"
					(mouseleave)="hideRailTip()">
					<i [class]="item.icon || 'pi pi-circle'"></i>
					@if (item.items?.length) {
					<span class="rail-dot"></span>
					} @if (item.badge) {
					<span class="rail-badge">{{ item.badge }}</span>
					}
				</button>
			</div>
			}
		</nav>

		<div class="sidebar__search sidebar__search--mini flex-shrink-0">
			<button
				class="rail-item"
				data-dict-key="select"
				(click)="sidebar.open()"
				(mouseenter)="showRailTip($event, searchLabel)"
				(mouseleave)="hideRailTip()">
				<i class="pi pi-search"></i>
			</button>
		</div>
	</div>
</section>

<!-- ----- Carte flyout, ancrée sur l'item du rail -->
@if (!sidebar.isOpen() && flyoutItem(); as item) {
<div
	class="sb-flyout"
	[style.top.px]="flyoutPos()?.top"
	[style.left.px]="flyoutPos()?.left"
	[style.max-height.px]="flyoutPos()?.maxHeight"
	(mousedown)="$event.stopPropagation()">
	<div class="fly-head">
		<i [class]="item.icon || 'pi pi-circle'"></i>
		<span class="truncate">{{ item.label }}</span>
	</div>
	<div class="fly-list">
		<ng-container *ngTemplateOutlet="flyLevel; context: { $implicit: item.items ?? [], depth: 0 }" />
	</div>
</div>
}

<!-- ----- Niveau de flyout — se rappelle lui-même pour les sous-niveaux -->
<ng-template #flyLevel let-items let-depth="depth">
	@for (child of items; track child.id) {
	<div
		class="fly-item"
		[class.fly-item--deep]="depth > 0"
		[class.fly-item--active]="child.styleClass?.includes('active-menu-item')"
		[class.fly-item--expanded]="flyoutExpandedIds().has(child.id)"
		(click)="child.items?.length ? toggleFlyoutSub(child.id) : onFlyoutItemClick(child, $event)">
		<span class="fly-label truncate">{{ child.label }}</span>
		@if (child.badge) {
		<span class="sidebar__count-badge">{{ child.badge }}</span>
		} @if (child.items?.length) {
		<span class="fly-chev"><lucide-icon [img]="lucideChevronRight" [size]="13" /></span>
		}
	</div>
	@if (child.items?.length && flyoutExpandedIds().has(child.id)) {
	<div class="fly-sub">
		<ng-container *ngTemplateOutlet="flyLevel; context: { $implicit: child.items, depth: depth + 1 }" />
	</div>
	} }
</ng-template>

<!-- ----- Infobulle du rail -->
@if (!sidebar.isOpen() && railTip(); as tip) {
<div class="rail-tip" [style.top.px]="tip.top" [style.left.px]="tip.left">{{ tip.label }}</div>
}
